import { useEffect } from "react"
import { Navigate } from "react-router-dom"
import { computed } from "mobx"
import { observer } from "mobx-react"

import { paths } from "@src/app/paths"
import { GRefundPage } from "@src/pages/refund/classes/RefundPage"
import { RefundForm } from "@src/shared/componemts/RefundForm"

export const RefundPage = observer(() => {
  const store = GRefundPage()

  const refund = computed(() => store.entity).get()

  useEffect(() => {
    return () => store.setEntity(null)
  }, [])

  if (!refund) {
    return <Navigate to={paths.default} />
  }

  return <RefundForm refund={refund} />
})
